import { type ComboboxItem } from "@mantine/core";

const getKey = (userId: string) => `report-favourite-types:${userId}`;

export const saveFavouriteReportTypes = (userId: string, values: string[]) => {
  try {
    localStorage.setItem(getKey(userId), JSON.stringify(values));
  } catch {
    // Storage unavailable: the favourites are just not remembered.
  }
};

export const loadFavouriteReportTypes = (userId: string): string[] => {
  try {
    const saved = JSON.parse(localStorage.getItem(getKey(userId)) ?? "null");
    return Array.isArray(saved) &&
      saved.every((value: unknown) => typeof value === "string")
      ? saved
      : [];
  } catch {
    return [];
  }
};

export const sortReportTypes = (
  items: ComboboxItem[],
  favourites: string[],
): ComboboxItem[] => {
  const byLabel = (a: ComboboxItem, b: ComboboxItem) =>
    a.label.localeCompare(b.label);
  return [
    ...items.filter(item => favourites.includes(item.value)).sort(byLabel),
    ...items.filter(item => !favourites.includes(item.value)).sort(byLabel),
  ];
};
